export const trafficSimulations = [
  {
    name: 'Traffic Flow Modeling',
    desc: 'Macro and mesoscopic network analysis',
    details: [
      {
        title: 'Volume & capacity analysis',
        desc: 'Assess road network load and identify bottlenecks',
      },
      {
        title: 'OD matrix modeling',
        desc: 'Origin-destination demand estimation and calibration',
      },
      {
        title: 'Level of service',
        desc: 'LOS assessment for intersections and corridors',
      },
    ],
  },
  {
    name: 'Microsimulation',
    desc: 'Vehicle-level dynamic traffic simulation',
    details: [
      {
        title: 'Intersection simulation',
        desc: 'Signal phasing, roundabouts, and priority control',
      },
      {
        title: 'Lane management',
        desc: 'Turn restrictions, lane drops, and weaving analysis',
      },
      {
        title: 'Emission modeling',
        desc: 'Vehicle emissions and environmental impact assessment',
      },
    ],
  },
  {
    name: 'Signal Optimization',
    desc: 'Adaptive and coordinated traffic control',
    details: [
      {
        title: 'Signal timing plans',
        desc: 'Green-wave coordination and cycle optimization',
      },
      {
        title: 'Adaptive control',
        desc: 'Real-time responsive signal strategies',
      },
      {
        title: 'Performance metrics',
        desc: 'Delay, queue length, and throughput KPIs',
      },
    ],
  },
  {
    name: 'Multimodal & Pedestrian',
    desc: 'Integrated transport and active mobility',
    details: [
      {
        title: 'Pedestrian simulation',
        desc: 'Crowd dynamics, crossings, and walkability analysis',
      },
      {
        title: 'Public transport',
        desc: 'Bus priority, transit lines, and modal integration',
      },
      {
        title: 'Cycling & micro-mobility',
        desc: 'Bike lane design and shared-space modeling',
      },
    ],
  },
]
